import React, { useState } from 'react';
import { FaRegPaperPlane } from "react-icons/fa6";
import Toast from '../Toast/Toast';
import { useTranslation } from 'react-i18next';

const Cta = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [toasts, setToasts] = useState([]);

  const handleSubscribe = () => {
    const showToast = (message, type = "error") => {
      setToasts([{ id: Date.now(), message, type }]);
      setTimeout(() => setToasts([]), 3000);
    };

    if (!email) {
      showToast(t("cta.validation"), "error");
      return;
    }

    console.log("Subscribing with email:", email);
    setShowPopup(true);
    setEmail("");
  };

  return (
    <div className="position-relative">
      <div
        className="p-5 rounded-5"
        style={{
          backgroundImage: "url('/images/cta-bg.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <h3 className="text-xl md:text-xl lg:text-4xl font-bold text-white text-center md:text-left">
          {t("cta.heading")}
        </h3>
        <p className="text-xl lg:text-2xl text-white mt-5 text-center md:text-left">
          {t("cta.subheading")}
        </p>

        {/* Desktop */}
        <div className="hidden md:block">
          <div className="flex justify-center">
            <div className="mt-5 bg-white rounded-pill d-flex align-items-center justify-between w-full h-10 md:h-10 lg:w-1/2 md:w-75 max-w-md">
              <h4 className="ps-3 text-md font-medium d-flex gap-3 align-items-center col-7">
                <span><FaRegPaperPlane /></span>
                <input
                  type="email"
                  placeholder={t("cta.emailPlaceholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="border-none outline-none bg-transparent w-full"
                />
              </h4>
              <button
                className="text-md col-4 bg-purple-800 rounded-pill text-white font-medium h-100"
                onClick={handleSubscribe}
              >
                {t("cta.subscribe")}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile */}
        <div className="block md:hidden">
          <div className="flex justify-center w-full">
            <div className="relative w-full max-w-md mt-5">
              <input
                type="email"
                placeholder={t("cta.emailPlaceholder")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full text-base border-none outline-none bg-white placeholder-gray-500 rounded-pill py-2 pr-12 pl-4"
              />
              <button
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-purple-800 text-white px-6 py-2 rounded-full flex items-center justify-center"
                onClick={handleSubscribe}
              >
                <FaRegPaperPlane size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      {showPopup && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded text-center">
            <h3 className="text-lg font-bold">{t("cta.thankYouTitle")}</h3>
            <p className="text-gray-600 mt-2">{t("cta.thankYouSubtext")}</p>
            <button
              className="mt-3 bg-purple-800 text-white px-4 py-2 rounded"
              onClick={() => setShowPopup(false)}
            >
              {t("cta.close")}
            </button>
          </div>
        </div>
      )}

      {/* Toasts */}
      <div className="fixed top-4 right-4 z-50 space-y-2">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            onClose={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}
          />
        ))}
      </div>
    </div>
  );
};

export default Cta;
